 <!-- Migration Expert Tool know more -->
 <div class="se-loader" *ngIf="loading"></div>
<div class="view-more" [ngClass]="{'body_Overlay': loading}" *ngIf="appId == 3">
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb mb-0">
            <li class="breadcrumb-item"><a href="javascript:;" routerLink="/overview">Back to overview</a></li>
            <li class="breadcrumb-item active" aria-current="page">{{AppName}}</li>
        </ol>
    </nav>
    <div class="intro-text mb-0">
        <img class="mb-3" style="max-width: 120px;" src="assets/image/umac.png" alt="umac" height="130" width="120">

        <div style="width: 350px; float: right" >
            <select class="se-form-controlInline darkgrey-bg" [(ngModel)]="defaultApp" (ngModelChange)="userSelectionChanged()" >
                <option *ngFor="let item of appFileDetails" value="{{item.fileName}}" >{{item.fileName}}</option>
            </select>
            <button class="se-button lnkdwnld"   title={{defaultApp}} [ngClass]="{'disabled': defaultApp == '',  'button-primary' : isAdmin == 'false' }"  [disabled]="defaultApp == ''" (click)="downloadEXE()"><span *ngIf="buttonText">{{buttonText}}</span> <span *ngIf="!buttonText">{{labels.download}} {{defaultAppName}}</span><span class="se-icon-action_download_stroke upload_icn"></span></button>
        </div>
        
        <h4>{{AppName}}</h4>
        <p>Unity M580 Application Converter (UMAC) simplifies the process of upgrading Unity Premium and Unity Quantum applications to Unity M580 with the following benefits:</p>
        <ul>
            <li>Reduced time for application conversion</li>
            <li>Better quality of converted applications</li>
            <li>Reduced testing time</li>
            <li>Faster availability of a fully functional application inside M580</li>
        </ul>
        <p>
            Unity M580 Application Converter complements the Unity Pro embedded converters (PL7 Pro, Concept etc). It is commercially available in 2 versions: Lite and Standard. The Lite version brings the original Quantum and Premium applications in the M580 world
            while retaining the local and remote I/O configurations as well as the application logic. The Standard version adapts the M580 applications appropriately to take care of topics such as replacement of I/O, automatic translation of Ethernet
            I/O scanner to DTMs, alignment constraints and any unsupported functions and descriptors etc.
        </p>
        <p>UMAC also provides an Evaluation Report, an estimation of the conversion labor saved using the tool, and a conversion report that lists the modifications brought to the application.</p>
        <p>UMAC Lite version is available to anyone and requires registration on the Schneider Electric Software Server. UMAC Standard requires an activation code and the availability is restricted to users with Customer Support Plans, or registered
            partners.
        </p>
        <p>UMAC V3.1 is compatible with any version of Unity Pro V12, V13 and V13.1 (XL or XLS) and Control Expert V14.0.</p>
        <p>As a reminder, we released UMAC V3.0 sometime ago and some of the features of UMAC V3.0 are</p>
        <ul>
            <li>Allows retaining 800 Series drops on S908 RIO network OR replacement with X80 EIO</li>
            <li>Allows retaining Quantum drops on S908 RIO network OR replacement with Quantum EIO OR replacement with X80 EIO</li>
            <li>Allows retaining Quantum drops on EIO network OR replacement with X80 EIO</li>
            <li>Replace Quantum drops on DIO network with Quantum EIO OR with X80 EIO</li>
            <li>For unsupported functions, empty DFBs that retain the program links and allow the user to edit inside the DFB </li>
            <li>Support for IEC_BMDI instruction in the library</li>
        </ul>
        <p>UMAC V3.1 will now allow you to retain your Premium I/O or replace them with X80 Extension or X80 EIO drops.</p>
        <p>As the legacy I/O modules are replaced with X80 modules, automatic ST code sections will be created to map the legacy state RAM or topological addressing into the Device DDT addressing supported by X80. This would ease the reprogramming
            effort and any impact on the DCS/Scada significantly.</p>
        <p>UMAC V3.0 and V3.1 allow you flexibility in retaining or replacing I/O drops per the customer need, schedule and budget. With our Quantum and Premium to X80 wiring systems, we have a complete solution to upgrade our legacy systems into
            our new platform easily and quickly.</p>
        <p>UMAC V3.2 supports Unity Premium and Quantum to Control Expert M340 and M580 application conversion.</p>
        <p>In addition to the features supported by UMAC V3.1, the major implemented features are:</p>
        <ul>
            <li>Conversion to M580 – Additional NOC modules supported</li>
            <li>Conversion to M580 – new X80 modules now available in the picklist</li>
            <li>Conversion to M340</li>
            <ul>
                <li>Option to convert smaller Quantum applications with lower end CPUs to M340</li>
                <li>Option to convert smaller Premium applications with lower end CPUs to M340</li>
            </ul>
            <li>Conversion from M340 to M580 now possible as well</li>
            <li>Bug fixes from previous releases as well as user interface improvements</li>
        </ul>
    </div>
</div>

<div class="se-dialog" *ngIf="warningPopup">
    <div class="se-dialog-holder">
        <div class="se-complex-header warning-head">
            <h3 class="se-dialiog-title">{{labels.note}}</h3>
        </div>
        <div class="se-dialog-body">
            <div class="notification-text">
                <p><span class="se-icon-information_stroke "></span>{{labels.downloadWarning}}</p>
           </div>
        </div>
        <div class="se-dialog-footer">
            <button class="se-button" (click)="close()">{{labels.close}}</button>
        </div>
    </div>
</div>

